'use client';

import React from 'react';
import { FlaskConical, RefreshCw, DollarSign } from 'lucide-react';

interface PaperTradingHeaderProps {
  onReset: () => void;
  totalEquity: number;
  totalReturn: number;
  totalReturnPct: number;
}

export default function PaperTradingHeader({
  onReset,
  totalEquity,
  totalReturn,
  totalReturnPct,
}: PaperTradingHeaderProps) {
  const isPositive = totalReturn >= 0;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
          <FlaskConical size={20} className="text-primary" />
        </div>
        <div>
          <h1 className="text-xl font-700 text-foreground">Paper Trading</h1>
          <p className="text-sm text-muted-foreground">
            Simulate trades with virtual cash — zero risk, real strategy testing
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {/* Equity pill */}
        <div className="flex items-center gap-2 bg-card border border-border rounded-xl px-4 py-2.5">
          <DollarSign size={15} className="text-muted-foreground" />
          <div>
            <p className="text-xs text-muted-foreground leading-none mb-0.5">Portfolio Value</p>
            <p className="text-sm font-700 text-foreground">
              ${totalEquity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
          </div>
          <span
            className={`text-xs font-600 px-2 py-0.5 rounded-full ${
              isPositive
                ? 'bg-emerald-500/10 text-emerald-400' :'bg-red-500/10 text-red-400'
            }`}
          >
            {isPositive ? '+' : ''}
            {totalReturnPct.toFixed(2)}%
          </span>
        </div>

        <button
          onClick={onReset}
          className="flex items-center gap-2 px-3 py-2.5 rounded-xl border border-border text-sm font-500 text-muted-foreground hover:text-foreground hover:border-primary/50 transition-all duration-150"
          title="Reset portfolio to $100,000"
        >
          <RefreshCw size={14} />
          <span className="hidden sm:inline">Reset</span>
        </button>
      </div>
    </div>
  );
}
